import type {
	createJiraEditorPluginAI,
	createJiraEditorPluginAIProvider,
} from '@atlassian/editor-plugin-ai/JiraPrebuilt';

// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum Product {
	JSW = 'JSW',
	JWM = 'JWM',
	JSM = 'JSM',
	JPD = 'JPD',
}

export type CreateEditorPluginAIProvider = ReturnType<typeof createJiraEditorPluginAIProvider>;
export type CreateEditorPluginAI = ReturnType<typeof createJiraEditorPluginAI>;
export type EditorPluginAI = CreateEditorPluginAI['editorPluginAI'];

/**
 * Currently just product required for EditorPluginAI but can add to this as needed
 * @link https://hello.atlassian.net/wiki/spaces/EDAI/pages/2731933104/Editor+AI+EAP+Part+2+Dev+Documentation+Prebuilt+Providers+Plugin+Presets
 */
export type EditorPluginAIConfig = {
	product: Product | null;
	isAiOptInEnabled: boolean;
	allowIssueReformatter?: boolean;
	getAdditionalProps?: () => Partial<{
		issue_summary?: string;
		issue_type_label?: string;
		issue_type_ari?: string;
	}>;
};

export type SharedEditorConfigProps = {
	editorPluginAIConfig?: EditorPluginAIConfig;
};

// Delete on FF cleanup of issue-view-admin-global-opt-in-ai
// Return type used for the shared editor
export type SharedEditorConfig = {
	dangerouslyAppendPlugins?: {
		__plugins: [EditorPluginAI] | [];
	};
};

// Return type used for the editor config
export type EditorConfig = {
	props: {
		dangerouslyAppendPlugins?: {
			__plugins: [EditorPluginAI] | [];
		};
	};
	components: {
		AIOptInModal: JSX.Element | null;
	};
};

type HandleFeedbackSubmission = NonNullable<
	Parameters<typeof createJiraEditorPluginAIProvider>[0]
>['handleFeedbackSubmission'];

export type HandleFeedbackSubmissionArgs = Parameters<NonNullable<HandleFeedbackSubmission>>[0];
